<template>
  <div class="container mx-auto">
    <el-dialog
      title="Nuevo tipo de documento"
      :visible.sync="showNewDocumentType"
      width="450px"
    >
      <el-form
        :model="newDocumentTypeForm"
        status-icon
        :rules="newDocumentTypeFormRules"
        ref="newDocumentType"
        @submit.native.prevent="
          submitNewDocumentType('newDocumentType', newDocumentTypeForm)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de documento" prop="name">
                  <el-input
                    placeholder="Nombre de documento"
                    v-model="newDocumentTypeForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Máscara" prop="mask">
                  <el-input
                    placeholder="Utilizar # para número y - (guiones) para separar y A para caracteres alfanuméricos"
                    v-model="newDocumentTypeForm.mask"
                    size="small"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-fa-question"
                      @click="showHelpMask"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="Alias" prop="shortName">
                  <el-input
                    placeholder="Alias"
                    v-model="newDocumentTypeForm.shortName"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item prop="required" style="margin-top: 11px">
                  <el-checkbox
                    class="w-full"
                    v-model="newDocumentTypeForm.required"
                    label="Requerido"
                    border
                    size="small"
                  ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewDocumentType = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Editar tipo de documento"
      :visible.sync="showEditDocumentType"
      width="450px"
    >
      <el-form
        :model="editDocumentTypeForm"
        status-icon
        :rules="editDocumentTypeFormRules"
        ref="editDocumentType"
        @submit.native.prevent="
          submitNewDocumentType(
            'editDocumentType',
            editDocumentTypeForm,
            editDocumentTypeForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de documento" prop="name">
                  <el-input
                    placeholder="Nombre de documento"
                    v-model="editDocumentTypeForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Máscara" prop="mask">
                  <el-input
                    placeholder="Utilizar # para número y - (guiones) para separar"
                    v-model="editDocumentTypeForm.mask"
                    size="small"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-fa-question"
                      @click="showHelpMask"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="Alias" prop="shortName">
                  <el-input
                    placeholder="Alias"
                    v-model="editDocumentTypeForm.shortName"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item prop="required" style="margin-top: 11px">
                  <el-checkbox
                    class="w-full"
                    v-model="editDocumentTypeForm.required"
                    label="Requerido"
                    border
                    size="small"
                  ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditDocumentType = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">DOCUMENTOS</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran los tipos de documentos nacionales que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewDocumentDialog"
              >Nuevo tipo de documento</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-table :data="filteredDocuments" stripe size="mini">
              <el-table-column type="index" width="40" />
              <el-table-column prop="shortName" label="Alias" min-width="110" />
              <el-table-column
                prop="name"
                label="Nombre documento"
                min-width="300"
              />
              <el-table-column prop="mask" label="Máscara" min-width="175" />
              <el-table-column label="Pais" min-width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.country.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Requerido" min-width="100" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.required ? "Sí" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.active">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="60" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button
                      icon="el-icon-fa-ellipsis-v"
                      size="small"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="openEditDocumentDialog(scope.row)"
                      >
                        <i class="el-icon-fa-pencil"></i> Editar información
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="changeStatus(scope.row)">
                        <span v-if="scope.row.active">
                          <i class="el-icon-fa-times"></i> Desactivar
                        </span>
                        <span v-else>
                          <i class="el-icon-fa-check"></i> Activar
                        </span>
                        documento
                      </el-dropdown-item>
                      <el-dropdown-item
                        :divided="true"
                        class="text-red-500 font-semibold"
                        @click.native="deleteDocument(scope.row)"
                      >
                        <i class="el-icon-fa-trash"></i> Eliminar
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="rawDocuments.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";

export default {
  name: "SettingsDocuments",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ documentTypes { id shortName name mask active required country { name } } }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.documentTypes));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    const validateMask = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback(new Error("Este campo es requerido."));
        return false;
      }

      var pattern = new RegExp(/^[#A-]*$/gm);
      if (!R.isNil(value) && !R.isEmpty(value) && !pattern.test(value)) {
        callback(new Error("Caracteres inválidos."));
        return false;
      }
      callback();
    };
    return {
      rawDocuments: [],
      searchValue: "",
      page: {
        size: 15,
        number: 1,
      },
      countries: [],
      showNewDocumentType: false,
      newDocumentTypeForm: {
        name: "",
        mask: "",
        shortName: "",
        country: null,
        required: false,
      },
      newDocumentTypeFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        mask: [{ validator: validateMask, trigger: "blur" }],
        shortName: [
          {
            required: true,
            message: "Por favor agrega un alias.",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Selecciona un país.",
            trigger: "change",
          },
        ],
      },
      showEditDocumentType: false,
      editDocumentTypeForm: {
        name: "",
        shortName: "",
        mask: "",
        country: null,
        required: false,
      },
      editDocumentTypeFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        mask: [{ validator: validateMask, trigger: "blur" }],
        shortName: [
          {
            required: true,
            message: "Por favor agrega un alias.",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Selecciona un país.",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    setData(data) {
      this.rawDocuments = data;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    changeStatus(document) {
      const action = document.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} este documento?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  documentTypeUpdateStatus
                  ( where: { id: ${document.id} } active: ${!document.active} )
                  { id shortName name mask active required country { name } }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawDocuments = data.documentTypeUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    deleteDocument({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este documento?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { documentTypeDelete( where: {id: ${id}} ) { id shortName name mask active required country { name } } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawDocuments = data.documentTypeDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el documento correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewDocumentDialog() {
      axios
        .post("/", {
          query: `{ countries { id name } }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.countries = data.countries;
          }
          const ref = this.$refs["newDocumentType"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showNewDocumentType = true;
        });
    },
    openEditDocumentDialog({ id }) {
      axios
        .post("/", {
          query: `
          { 
            documentType(where: { id: ${id} }) { id shortName name mask active required country { id name } } 
            countries { id name }
          }
          `,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            const country = data.documentType.country.id;
            this.editDocumentTypeForm = { ...data.documentType, country };
            this.countries = data.countries;
          }
          const ref = this.$refs["editDocumentType"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditDocumentType = true;
        });
    },
    submitNewDocumentType(
      formName,
      { name, shortName, country, mask, required },
      documentTypeid = false
    ) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = documentTypeid ? "editar" : "crear";
        const mutation = documentTypeid
          ? `documentTypeEdit(
              data: { 
                name: "${name}", 
                shortName: "${shortName}" 
                mask: ${R.isNil(mask) ? null : `"${mask}"`} 
                country: ${country}
                required: ${required}
              } 
              where: { id: ${documentTypeid} } )`
          : `documentTypeCreate(
              data: { 
                name: "${name}", 
                shortName: "${shortName}" 
                mask: ${R.isNil(mask) ? null : `"${mask}"`} 
                country: ${country}
                required: ${required}
              } )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} este documento?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { id shortName name mask active required country { name } } 
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawDocuments = documentTypeid
                        ? data.documentTypeEdit
                        : data.documentTypeCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha creado el documento correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewDocumentType = false;
                    this.showEditDocumentType = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    showHelpMask() {
      this.$alert(
        "Se aceptan solamente los caracteres # (para representar numeros) y - (como separador). Ejemplo: ###-### y A para caracteres alfanuméricos.",
        "Máscara",
        {
          confirmButtonText: "Enterado",
        }
      );
    },
  },
  computed: {
    filteredDocuments() {
      return this.rawDocuments
        .filter((document) => {
          return (
            document.name
              .toLowerCase()
              .includes(this.searchValue.toLowerCase()) ||
            document.shortName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase()) ||
            document.country.name
              .toLowerCase()
              .includes(this.searchValue.toLowerCase())
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>

<style></style>
